import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Wish} from '../../core/model/wish';

@Injectable({providedIn: 'root'})
export class WishService {
  public resourceUrl = environment.SERVER_API_URL + 'api/recipes';

  constructor(private http: HttpClient) {
  }

  getWish(recipeId: number): Observable<Wish> {
    return this.http.get<Wish>(`${this.resourceUrl}/${recipeId}/wishes`);
  }

  addWish(recipeId: number): Observable<void> {
    return this.http.post<void>(`${this.resourceUrl}/${recipeId}/wishes`, recipeId);
  }

  removeWish(recipeId: number): Observable<void> {
    return this.http.delete<void>(`${this.resourceUrl}/${recipeId}/wishes`);
  }
}
